export var randomColorArr = [
    {
        textColor: "txt_cinnabar",
        backgroundColor: "bg_flesh",
    },
    {
        textColor: "txt_marian-blue",
        backgroundColor: "bg_magnolia-white",
    },
    {
        textColor: "txt_cadmium-orange",
        backgroundColor: "bg_desert-sand2",
    },
    {
        textColor: "txt_cinnabar2",
        backgroundColor: "bg_pale-pink",
    },
    {
        textColor: "txt_burnt-sienna",
        backgroundColor: "bg_misty-rose2",
    },
    {
        textColor: "txt_yInMn-blue",
        backgroundColor: "bg_pale-aqua2",
    },
    {
        textColor: "txt_persian-red",
        backgroundColor: "bg_piggy-pink",
    },
    {
        textColor: "txt_verdigris",
        backgroundColor: "bg_cool-mint3",
    },
    {
        textColor: "txt_deep-carrot-orange",
        backgroundColor: "bg_dutch-white",
    },
];
export var alphabetsColorsConfigMap = new Map([
    [
        "a",
        { textColor: "txt-cornflower-blue", backgroundColor: "bg-lavender-mist5" },
    ],
    ["b", { textColor: "txt-broccoli-green", backgroundColor: "bg-dark-cream" }],
    ["c", { textColor: "txt-granite-gray", backgroundColor: "bg-gainsboro3" }],
    ["d", { textColor: "txt-dark-chestnut", backgroundColor: "bg-misty-rose3" }],
    ["e", { textColor: "txt_dark-purple", backgroundColor: "bg-cameo-pink" }],
    [
        "f",
        { textColor: "txt_rich-electric-blue", backgroundColor: "bg-cool-mint" },
    ],
    ["g", { textColor: "txt-phthalo-green", backgroundColor: "bg-aero-blue" }],
    ["h", { textColor: "txt-coffee", backgroundColor: "bg-light-nude" }],
    ["i", { textColor: "txt_dark-purple", backgroundColor: "bg-piggy-pink" }],
    ["j", { textColor: "txt-pale-brown", backgroundColor: "bg-parchment" }],
    ["k", { textColor: "txt-onyx", backgroundColor: "bg-light-gray2" }],
    [
        "l",
        { textColor: "txt-dark-blue-gray", backgroundColor: "bg-lavender-mist6" },
    ],
    ["m", { textColor: "txt-nickel2", backgroundColor: "bg-beige" }],
    [
        "n",
        { textColor: "txt-cerulean-blue", backgroundColor: "bg-lavender-mist7" },
    ],
    ["o", { textColor: "txt-artichoke", backgroundColor: "bg-eggshell" }],
    ["p", { textColor: "txt_dark-purple", backgroundColor: "bg_blush-pink" }],
    ["q", { textColor: "txt-dark-buff", backgroundColor: "bg-peach-puff" }],
    ["r", { textColor: "txt-eucalyptus-green", backgroundColor: "bg-oatmeal" }],
    [
        "s",
        { textColor: "txt_rich-electric-blue", backgroundColor: "bg-cool-mint" },
    ],
    [
        "t",
        { textColor: "txt-dark-chestnut2", backgroundColor: "bg-chilean-pink" },
    ],
    ["u", { textColor: "txt-old-moss-green", backgroundColor: "bg-timberwolf" }],
    ["v", { textColor: "txt-iris", backgroundColor: "bg-white-violet" }],
    ["w", { textColor: "txt_dark-purple", backgroundColor: "bg-pink-pear" }],
    ["x", { textColor: "txt-brass", backgroundColor: "bg-bone" }],
    ["y", { textColor: "txt-cadet-blue", backgroundColor: "bg-cool-mint4" }],
    ["z", { textColor: "txt-antique-brass", backgroundColor: "bg-misty-rose3" }],
]);
